import { render, staticRenderFns } from "./AegCaseLiabilitySignboard.vue?vue&type=template&id=3484f2e6"
import script from "./AegCaseLiabilitySignboard.vue?vue&type=script&lang=js"
export * from "./AegCaseLiabilitySignboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports